// Product page accordion toggle
document.addEventListener('DOMContentLoaded', function () {
  const triggers = document.querySelectorAll('.maxx-accordion-item__trigger');
  triggers.forEach(function (trigger) {
    const item = trigger.closest('.maxx-accordion-item');
    trigger.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');
      // Close all
      document.querySelectorAll('.maxx-accordion-item').forEach(function (el) {
        el.classList.remove('is-open');
        el.querySelector('.maxx-accordion-item__trigger').setAttribute('aria-expanded', 'false');
      });
      // Toggle clicked item open if it was closed
      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
});
